/**
 * S7.6-A — OfflineAgingBadge
 *
 * Badge com 4 níveis de "saúde de conectividade" baseado em last_seen:
 *   online (≤2 min)   verde  badge-ok
 *   warn   (>10 min)  amarelo badge-warn
 *   alert  (>1 h)     laranja (classes inline Tailwind, padrão do projeto)
 *   stale  (>24 h)    cinza  badge-muted
 *
 * Texto visível: tempo relativo via formatRelative ("12m atrás").
 * Texto do tooltip: nível textual i18n ("Offline há mais de 1 hora").
 *
 * Mantém o StatusBadge.jsx original intacto — este componente é
 * novo e específico para contextos onde o tempo desde o último
 * heartbeat importa (DevicesList coluna "Last Seen", Inventory Card).
 */
import { formatRelative, offlineAgingLevel } from "../lib/format.js";
import { t } from "../i18n/index.js";

const LEVEL_CLASS = {
  online: "badge-ok",
  warn:   "badge-warn",
  alert:  "inline-flex items-center gap-1 px-2 py-0.5 rounded-md "
        + "text-xs font-medium "
        + "text-noc-orange bg-noc-orange/10 border border-noc-orange/30",
  stale:  "badge-muted",
};

const LEVEL_LABEL_KEY = {
  online: "offlineAging.online",
  warn:   "offlineAging.warn",
  alert:  "offlineAging.alert",
  stale:  "offlineAging.stale",
};

export default function OfflineAgingBadge({ lastSeen }) {
  const level = offlineAgingLevel(lastSeen);
  const klass = LEVEL_CLASS[level];
  const tooltip = t(LEVEL_LABEL_KEY[level]);
  // Texto visível: tempo relativo ("12m atrás", "2h atrás"). Para
  // level=online queremos exibir "online" puro (mais legível que
  // "1m atrás"). Para os outros, formatRelative.
  const text = level === "online"
    ? t("offlineAging.online")
    : formatRelative(lastSeen);
  return (
    <span className={klass} title={tooltip}>
      {text}
    </span>
  );
}
